import { ILocalStorage } from "../api/ILocalStorage";

import { LandinPageStorage } from "../impl/LandinPageStorage";
import { MemoryStorage } from "../impl/MemoryStorage";
import { WindowLocalStorage } from "../impl/WindowLocalStorage";

import { ExternalInterface } from "@goodgamestudios/createjs-utilities";

/**
 * LocalStorage factory, used to instantiate concrete LocalStorage class based on current environment.
 */
export class LocalStorageFactory {
    /**
     * To be able to use window.localStorage, we should first verify that it is supported and available in the current browsing session.
     *
     * @link https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API/Using_the_Web_Storage_API
     */
    private static isWindowLocalStorageAvailable(): boolean {
        let storage: Storage;
        let x: string;

        try {
            storage = window.localStorage;
            x = "__storage_test__";

            storage.setItem(x, x);
            storage.getItem(x);
            storage.removeItem(x);

            return true;
        } catch (error) {
            return false;
        }
    }

    /**
     * Create concrete LocalStorage wrapper based on current environment.
     */
    public static createLocalStorage(section: string): ILocalStorage {
        if (ExternalInterface.available) {
            return new LandinPageStorage(section);
        } else if (LocalStorageFactory.isWindowLocalStorageAvailable()) {
            return new WindowLocalStorage(section);
        } else {
            return new MemoryStorage(section);
        }
    }
}
